.trigger {
  cursor: pointer;
}

.value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  display: flex;
  flex: none;
  transition: transform 120ms ease-out;
}

.trigger[data-popup-open] .chevron {
  transform: rotate(180deg);
}

.positioner {
  z-index: 10;
  outline: none;
}

/* Zumpo/Select menu */
.popup {
  box-sizing: border-box;
  width: var(--anchor-width);
  max-height: var(--available-height);
  padding: var(--zumpo-space-8);
  overflow-y: auto;
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-12);
  background: var(--zumpo-paper);
  box-shadow: var(--zumpo-shadow-menu-lift);
  outline: none;
  transform-origin: var(--transform-origin);
  transition:
    opacity 120ms ease-out,
    transform 120ms ease-out;
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: translateY(-4px);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-2);
}

/* Options with a second line sit flush, as on the Board menu. */
.list:has(.detail) {
  gap: 0;
}

/* Zumpo/Select option */
.option {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
  padding: var(--zumpo-space-10) var(--zumpo-space-12);
  border-radius: var(--zumpo-radius-8);
  color: var(--zumpo-ink);
  cursor: pointer;
  outline: none;
  user-select: none;
}

/* Two lines of text: Figma tightens the padding to keep the option 56 high. */
.withDetail {
  padding-block: var(--zumpo-space-8);
}

.option[data-highlighted] {
  background: var(--zumpo-cream);
}

.option[data-selected],
.option[data-checked] {
  background: var(--zumpo-lime);
}

/* A choice list lays its options out in the page, 8 px apart (MS01). */
.choices {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-8);
}

/* In the page, hover and focus show, and two lines keep the full padding. */
.choice {
  margin: 0;
  border: 0;
  background: transparent;
  text-align: left;
}

.choice.withDetail {
  padding-block: var(--zumpo-space-10);
}

@media (hover: hover) {
  .choice:hover:not([data-checked]) {
    background: var(--zumpo-cream);
  }
}

.choice:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--zumpo-space-2);
  min-width: 0;
}

.optionLabel {
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.detail {
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
}

.option[data-selected] .detail,
.option[data-checked] .detail {
  color: var(--zumpo-ink);
}

.check {
  display: flex;
  flex: none;
}

@media (prefers-reduced-motion: reduce) {
  .chevron,
  .popup {
    transition: none;
  }
}
